import React, { useMemo } from "react";

const NotePhase = ({ note }) => {
	const displayName = useMemo(() => {
		if (note?.isRiskNote) {
			return "Risk Note";
		}

		if (
			note?.phase?.displayName === "Underwriting Note" &&
			note?.isPrivate
		) {
			return "Underwriting Private Note";
		}

		if (!note?.phase || note?.phase?.displayName === "None") {
			return null;
		}

		return note?.phase?.displayName;
	}, [note]);

	if (displayName === null) {
		return null;
	}

	return (
		<div className="mb-1">
			<span className="text-grey mr-3">Type</span>
			{displayName}
		</div>
	);
};

export default NotePhase;
